"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      margin: theme.spacing(0.5)
    },
    deleteIcon: {
      color: theme.palette.primary.light,
      '&:hover': {
        color: theme.palette.primary.main
      }
    }
  };
});
var Chip = function Chip(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Chip["default"], _extends({}, props, {
    classes: classes
  }));
};
Chip.propTypes = {
  label: _propTypes["default"].string.isRequired,
  onDelete: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = Chip;